// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"dea175bb","571":"27e847ca","589":"66d00096"}[chunkId] + ".chunk.css";
};